import { render, staticRenderFns } from "./simplifyOwnerMember.vue?vue&type=template&id=2971c0f8&scoped=true"
import script from "./simplifyOwnerMember.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerMember.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerMember.vue?vue&type=style&index=0&id=2971c0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971c0f8",
  null
  
)

export default component.exports